import React, {useState} from "react";
import { Box, Checkbox, Column, Columns, Input, TextArea, Title } from "@allxsmith/bestax-bulma";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import useButtonSelect from "../../hooks/useButtonSelect";
import ContactSection from "../Contact/ContactSection";
import DriverPicker from "../Settings/Driver/DriverPicker";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";


export default function MovementSupplierSection({data, onChange, onCheck, departments, onDepartmentChange, endpoint, onSearchedObjChange,
                                                    drivers, onDriverChange, onCustomerChange}){

    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [typeahead, setTypeahead] = useState();

    const handleCustomerChange = e => {
        // wrapper for more generic function
        onCustomerChange(e, "external_supplier")
    }

    const handleVehicleUsedChange = e => {
        onSearchedObjChange(e, "vehicle_used")
    }

    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const supplierStatusOptions = [
        {name: "Internal", value: "INTERNAL"},
        {name: "External", value: "EXTERNAL"}
    ];



    const [supplierStatus, supplierStatusInput] = useButtonSelect({
        label: "Supplier Status",
        initialValue: "INTERNAL",
        prop: "supplier_status",
        options: supplierStatusOptions,
        callback: onChange
    });



    // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
    return (
        <Box>
            <Columns isMultiline>
                <Column>
                    <Title>Movement Supplier Section</Title>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    {supplierStatusInput}
                </Column>
                <Column>
                    <DepartmentSelector
                        name={"movement_performer"}
                        label={"Supplier"}
                        value={data.movement_performer}
                        options={departments}
                        onChange={onDepartmentChange}
                        editable={true}
                        blank={true}
                    />
                </Column>
                <Column>
                    <label className="label">Driver Job Number</label>
                    <Input
                        name={"driver_sequence_number"}
                        value={data.driver_sequence_number}
                        onChange={onChange}
                        type={"number"}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Vehicle Used</label>
                    <AsyncTypeahead
                          useCache={false}
                          isLoading={loading}
                          id="typeahead"
                          labelKey="registration"
                          minLength={2}
                          name={"vehicle_used"}
                          onSearch={handleVehicleSearch}
                          onChange={handleVehicleUsedChange}
                          placeholder={`Search Vehicle`}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          selected={(data.vehicle_used && data.vehicle_used.id) ? [data.vehicle_used] : []}
                    />
                </Column>
                <Column>
                    <DriverPicker
                        label={"Driver"}
                        options={drivers}
                        onChange={onDriverChange}
                        editable={true}
                        blank={true}
                        value={data.driver}
                    />
                </Column>
                <Column>
                    <label className="label">Job Comments</label>
                    <TextArea
                        name={"supplier_comments"}
                        value={data.supplier_comments}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Work Complete</label>
                    <Checkbox
                        checked={data.work_complete}
                        name={"work_complete"}
                        onChange={onCheck}
                    />
                </Column>
                {data.completed &&
                <Column>
                    <label className="label">BLANK</label>
                    <Input
                        value={"APPROVED"}
                        disabled={true}
                    />
                </Column>
                }
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Internal Charge</label>
                    <Input
                        type={"number"}
                        value={data.internal_charge}
                        name={"internal_charge"}
                        onChange={onChange}
                        disabled={!data.supplier_cost_override}
                    />
                </Column>
                <Column>
                    <label className="label">Internal Charge Cost Override</label>
                    <Checkbox
                        checked={data.supplier_cost_override}
                        name={"supplier_cost_override"}
                        onChange={onCheck}
                    />
                </Column>
                <Column>
                    <label className="label">Additional Internal Charge</label>
                    <Input
                        name={"internal_additional_charge"}
                        value={data.internal_additional_charge}
                        onChange={onChange}
                        type={"number"}
                    />
                </Column>
                <Column>
                    <label className="label">Total Internal Charge</label>
                    <Input
                        disabled={true}
                        value={parseFloat(data.internal_charge) + parseFloat(data.internal_additional_charge)}
                    />
                </Column>
            </Columns>
            {data.supplier_status === "EXTERNAL" &&
                <Columns isMultiline>
                    <Column>
                        <ContactSection
                            title={"External Supplier"}
                            contactUpdate={handleCustomerChange}
                            endpoint={endpoint+"contacts"}
                            contact={data.external_supplier || {}}
                            type={"SP"}
                        />
                    </Column>
                </Columns>
            }
            {data.supplier_status === "EXTERNAL" &&
                <Columns isMultiline>
                    <Column>
                        <label className="label">External Supplier Charge</label>
                        <Input
                            type={"number"}
                            name={"external_supplier_charge"}
                            value={data.external_supplier_charge}
                            onChange={onChange}
                            disabled={!data.external_supplier_charge_override}
                        />
                    </Column>
                    <Column>
                        <label className="label">External Supplier Charge Override</label>
                        <Checkbox
                            name={"external_supplier_charge_override"}
                            checked={data.external_supplier_charge_override}
                            onChange={onCheck}
                        />
                    </Column>
                </Columns>
            }
        </Box>
    );



}